import { useMutation , useQueryClient} from "@tanstack/react-query";
import { toast } from "react-toastify";
import { cartNfts } from "../../API/functions";

export const useCartNfts = () => {
  const queryClient = useQueryClient();
  const mutationFn = ({ nftId, walletAddress, action ,contract_address}) => cartNfts(nftId, walletAddress, action,contract_address);
  const { mutate ,isPending } = useMutation({
    mutationFn,
    onSuccess: (result) => {
      queryClient.invalidateQueries(["cartNft"]);
      toast.success(result.message);
    },
   
  });

  return { mutate,isPending };
};
